import { createFileRoute } from '@tanstack/react-router';

// Écran carte sans fiche : tout est rendu par la mise en page `_carte` (filtres, vue et cadrage dans l'URL).
export const Route = createFileRoute('/_carte/')({});
